import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BlockedDatesOverviewComponent } from './blocked-dates-overview/blocked-dates-overview.component';

const routes: Routes = [
  {
    path: 'blocked-delivery-dates',
    component: BlockedDatesOverviewComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BlockedDeliveryDateRoutingModule { }
